import styled, { keyframes } from 'styled-components';

const pulseAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

export const ShoppableContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  overflow: visible;
`;

export const ShoppableImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const HotspotButton = styled.button`
  z-index: 2;
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-18px, -18px);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: 1;
`;

export const SolidCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  animation: ${pulseAnimation} 3s infinite;
`;

export const OutlineCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid white;
  background-color: transparent;
  position: absolute;
  animation: ${pulseAnimation} 3s infinite;
`;
